import Hero from '../../components/Hero';
import SlideGallery from '../../components/SlideGallery';
import Footer from '../../components/Footer';

export default function Inicio() {
    return (
        <main className="g-main inicio">
            <Hero title='Bienvenido' description='Por la Gracia de Dios y el Testimonio de Jesucristo. Apocalipsis 1:9' size='l' />
            <section className='content-main'>
                {/* <SlideGallery /> */}
            </section>
            <Footer />
        </main>
    );
}